export default "__VITE_PUBLIC_ASSET__955ded6e__"